import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError('');
      setMessage('');
      setLoading(true);
      
      const response = await axios.post('/auth/forgot-password', { email });
      setMessage(response.data.message);
      setEmail(''); // Clear the form
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('An error occurred. Please try again.');
      }
    }
    
    setLoading(false);
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                <h2>Forgot Password</h2>
                <p className="text-muted">
                  Enter your email address and we'll send you instructions to reset your password.
                </p>
              </div>
              
              {message && <Alert variant="success">{message}</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                  />
                  <Form.Text className="text-muted">
                    We'll send reset instructions to both your email and phone (if provided).
                  </Form.Text>
                </Form.Group>
                
                <Button 
                  disabled={loading} 
                  className="w-100 mb-3" 
                  type="submit"
                  variant="primary"
                >
                  {loading ? 'Sending...' : 'Send Reset Instructions'}
                </Button>
              </Form>
              
              <div className="text-center">
                <p>
                  Remember your password? <Link to="/login">Back to Login</Link>
                </p>
              </div>
              
              <div className="text-center mt-3">
                <small className="text-muted">
                  Don't have an account? <Link to="/register">Sign up here</Link>
                </small>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;